// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._skeleton_1yep9_1 {
  --pa-comparison-header-skeleton-border-width-inner: var(--pa-comparison-header-skeleton-border-width, 0);
  --perxis-auto-header-border-width: var(--pa-comparison-header-skeleton-border-width-inner);
  --perxis-auto-header-padding: 0;
}
._skeleton__title_1yep9_6 {
  width: 180px;
  height: 28px;
}
@media (min-width: 1200px) {
  ._skeleton__title_1yep9_6 {
    width: 330px;
    height: 36px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._skeleton__title_1yep9_6 {
    width: 250px;
    height: 32px;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  ._skeleton__title_1yep9_6 {
    width: 200px;
    height: 28px;
  }
}
._skeleton__back_1yep9_28, ._skeleton__button_1yep9_28 {
  width: 120px;
  height: 24px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
